import React from 'react'
import cognitoUtils from '../utils/cognitoUtils';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  signInButton: {
    width: '100%',
  },
}));

const LandingPage = () => {
  const classes = useStyles();

  return (
    <Button
      component={ Link }
      href={cognitoUtils.getCognitoSignInUri()}
      variant="contained"
      color="primary"
      className={classes.signInButton}
    >
      Sign in
    </Button>
  );
};

export default LandingPage;
